<template>
	<div
		:id="uid"
		:class="[
			'vendors-card',
			modelValue.hasErrorTransactions && 'has-error'
		]"
	>
		<div class="vendors-card__status">
			<NotificationIcon
				:variant="notificationVariantIcon"
				ref="tooltipStatusRef"
				@mouseenter="tooltipStatusVisible = true"
				@focus="tooltipStatusVisible = true"
				@mouseleave="tooltipStatusVisible = false"
				@blur="tooltipStatusVisible = false"
			/>
			<Tooltip
				:text="vendorStatus"
				:trackedRefName="'tooltipStatusRef'"
				:display="tooltipStatusVisible"
				:offset="[4, 4]"
				position="top-start"
			/>
		</div>
		<div class="vendors-card__main">
			<Ellipsis
				:data="modelValue.integratorName"
				class="vendors-card__title"
			></Ellipsis>
			<div class="vendors-card__data">
				<span class="vendors-card__data-int">{{
					modelValue.integratorCode
				}}</span>
				<span
					class="vendors-card__data-separator"
					v-if="modelValue.alias"
					>|</span
				>
				<Ellipsis
					:data="modelValue.alias"
					v-if="modelValue.alias"
				></Ellipsis>
			</div>
			<div class="vendors-card__integration-solution">
				<TagLabel
					v-if="modelValue.dependentsCount"
					message="DMS Integration Solution"
					:subMessage="modelValue.dependentsCount"
					:variant="'hyperlink'"
					@click="showDependentModal"
					data-testid="withDependents"
				/>
				<TagLabel
					v-if="modelValue.useAggregatorIntegrations"
					message="USES DMS-IS"
					:state="'secondary-2'"
					data-testid="displayIfDMSIS"
				/>
				<TagLabel
					v-if="modelValue.useDirectIntegrations"
					message="DIRECT"
					:state="'secondary-1'"
					data-testid="displayIfDirect"
				/>
			</div>
		</div>
		<ActionsSet
			class="vendors-card__actions"
			:id="`${uid}_action`"
			:variant="variant"
			:options="actions"
		/>
	</div>
</template>

<script>
import ActionsSet from '@/site-components/actions-set/actions-set';
import Tooltip from '@/components/shells/tooltip/tooltip';
import TagLabel from '@/components/visual/tag-label';
import NotificationIcon from '@/components/notifications/notification-icon/notification-icon';
import Ellipsis from '@/components/visual/ellipsis';

// mixins
import VendorsActions from './vendors-actions';

export default {
	name: 'VendorsSummaryCard',
	model: {
		prop: 'modelValue'
	},
	components: {
		ActionsSet,
		Tooltip,
		TagLabel,
		NotificationIcon,
		Ellipsis
	},
	mixins: [VendorsActions],
	props: {
		modelValue: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			tooltipStatusVisible: false,
			tooltipTitleVisible: false,
			tooltipCodeVisible: false
		};
	},
	created() {
		this.vendor = this.modelValue;
	},
	computed: {
		vendorStatus() {
			if (this.modelValue.hasErrorTransactions) {
				return 'Transaction Error';
			}
			if (!this.modelValue.active) {
				return 'Inactive Vendor';
			}
			return 'Active Vendor';
		},
		notificationVariantIcon() {
			if (this.modelValue.hasErrorTransactions) {
				return 'negative';
			}
			if (!this.modelValue.active) {
				return 'inactive';
			}
			return 'positive';
		}
	},
	methods: {
		showDependentModal() {
			this.$emit('showDependentModal');
		},
		showCustomerModal() {
			this.$emit('showCustomerModal');
		}
	}
};
</script>

<style lang="scss" scoped>
/**
    * Vendors Card
 */

@import '@/scss/5-objects/_cards.scss';

.vendors-card {
	@include card;
	display: grid;
	grid-template-columns: auto 1fr;
	column-gap: $gutter-lg;
	row-gap: $gutter-md;
	align-items: start;
	font-size: $default-font-size - 2;

	&.has-error {
		@include card('error');
	}

	&__main {
		min-width: 0;
	}

	&__status {
		position: relative;
		@include vertical-horizontal-center-with-flex;
		z-index: 1;
		cursor: default;
	}

	&__title {
		cursor: default;
		@include heading('md');
		text-transform: capitalize;
		margin-bottom: $gutter-sm;
	}

	&__data {
		display: flex;
		gap: $gutter-sm;
		@include body-text('regular');
	}

	&__data-int {
		min-width: fit-content;
	}

	&__data-separator {
		line-height: 1;
	}

	&__integration-solution {
		display: flex;
		flex-wrap: wrap;
		gap: $gutter-md;
		margin-top: $gutter-lg;
		margin-bottom: $gutter-md;
	}

	&__actions {
		grid-column: 2/3;
		align-self: flex-end;
		display: flex;
		flex-direction: column;
	}
}
</style>
